var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputer = function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 26v50.5h-93V26a6.5 6.5 0 0 1 6.5-6.5h80a6.5 6.5 0 0 1 6.5 6.5ZM116 109.5h0H12h0a6.496 6.496 0 0 1-5.45-2.957 6.5 6.5 0 0 1-.494-6.175L16.964 76.5h94.072l10.905 23.861.003.007A6.5 6.5 0 0 1 116 109.5ZM56 96h16",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgComputer;